import { useState } from 'react';
import { orderCommissions, packageCommissions, commissionRate } from '@/mocks/finance';

type CommType = 'orders' | 'packages';

export default function CommissionsTab() {
  const [type, setType] = useState<CommType>('orders');

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-semibold text-[15px] text-foreground-950">تفصيل العمولات</h3>
        <div className="flex items-center gap-1">
          {([['orders', 'طلبات'], ['packages', 'باقات']] as const).map(([val, label]) => (
            <button
              key={val}
              type="button"
              onClick={() => setType(val)}
              className={[
                'rounded-btn px-4 py-2 text-[13px] font-medium transition-colors',
                type === val
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-500 hover:bg-background-100',
              ].join(' ')}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-card border border-background-200 bg-secondary-50 p-4">
        <p className="text-[13px] text-foreground-600">
          نسبة عمولة الإدارة المطبقة:
          <span className="ms-2 font-bold text-[16px] text-primary-600">{commissionRate}%</span>
        </p>
      </div>

      {type === 'orders' ? (
        <div className="overflow-hidden rounded-card border border-background-200 bg-white shadow-card">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[860px] border-collapse text-right">
              <thead>
                <tr className="bg-background-50">
                  {['رقم الطلب', 'التاريخ', 'قيمة الطلب', 'عمولة الإدارة', 'المبلغ المخصوم', 'رسوم التوصيل', 'صافي المستحق'].map(
                    (h) => (
                      <th key={h} className="whitespace-nowrap px-4 py-3 font-semibold text-[12px] text-foreground-500">
                        {h}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {orderCommissions.map((row, index) => (
                  <tr
                    key={row.orderNo}
                    className={index > 0 ? 'border-t border-background-100' : ''}
                  >
                    <td className="px-4 py-3.5 font-semibold text-[13px] text-secondary-600">{row.orderNo}</td>
                    <td className="px-4 py-3.5 text-[12px] text-foreground-500">{row.date}</td>
                    <td className="px-4 py-3.5 text-[13px] font-medium text-foreground-900">{row.amount} ر.س</td>
                    <td className="px-4 py-3.5 text-[13px] text-foreground-600">{row.rate}%</td>
                    <td className="px-4 py-3.5 text-[13px] text-danger-600">- {row.deducted} ر.س</td>
                    <td className="px-4 py-3.5 text-[13px] text-foreground-600">{row.transferred} ر.س</td>
                    <td className="px-4 py-3.5 font-semibold text-[13px] text-success-700">{row.net} ر.س</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="overflow-hidden rounded-card border border-background-200 bg-white shadow-card">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[740px] border-collapse text-right">
              <thead>
                <tr className="bg-background-50">
                  {['اسم الباقة', 'العميل', 'التاريخ', 'قيمة الباقة', 'عمولة الإدارة', 'صافي المستحق'].map(
                    (h) => (
                      <th key={h} className="whitespace-nowrap px-4 py-3 font-semibold text-[12px] text-foreground-500">
                        {h}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {packageCommissions.map((row, index) => (
                  <tr
                    key={`${row.name}-${row.date}`}
                    className={index > 0 ? 'border-t border-background-100' : ''}
                  >
                    <td className="px-4 py-3.5 font-medium text-[13px] text-foreground-900">{row.name}</td>
                    <td className="px-4 py-3.5 text-[13px] text-foreground-700">{row.customer}</td>
                    <td className="px-4 py-3.5 text-[12px] text-foreground-500">{row.date}</td>
                    <td className="px-4 py-3.5 font-medium text-[13px] text-foreground-900">{row.amount} ر.س</td>
                    <td className="px-4 py-3.5 text-[13px] text-danger-600">- {row.amount * row.rate / 100} ر.س</td>
                    <td className="px-4 py-3.5 font-semibold text-[13px] text-success-700">{row.net} ر.س</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}